import React, { Component } from "react";
import "./Layout.css";
import Copyright from "../Copyright/Copyright";

class LayoutRegister extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.children}
        <div className={"Footer"}>
          <Copyright />
        </div>
      </React.Fragment>
    );
  }
}
export default LayoutRegister;



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutRegister.jsx